import {Column, Entity} from "typeorm";
import {BaseEntity} from "@/modules/base/entity/BaseEntity";
import type {SettingType} from "@/modules/settings/resources/settings";

@Entity()
export class Setting extends BaseEntity {
  @Column({type: "varchar"})
  name: SettingType;

  @Column({type: "varchar"})
  rawValue: string;

  set value(value: boolean | string | number | null | undefined) {
    this.rawValue = JSON.stringify({value});
  }

  get value() {
    const {value} = JSON.parse(this.rawValue);

    return value;
  }
}
